const languageFromCode = {
  us: 'English',
  es: 'Español',
  pt: 'Português'
};

export const i18nLocaleSelector = (state): string =>
  state && state.i18n && state.i18n.locale;

export const getTranslationOptions = (state) => {
  const { allIds } = state.i18n;

  return allIds.map((key: keyof typeof languageFromCode) => ({
    country: key,
    label: languageFromCode[key] || key.toUpperCase()
  }));
};
